import React, { useEffect, useState } from 'react';
import { Table, Card, Spin, Menu, Tag } from 'antd';
import { EditOutlined, DownloadOutlined } from '@ant-design/icons';
import utils from '../utils/index';
import MoreTableData from './moreTableData';
import { CSVLink } from 'react-csv';
import EllipsisDropdown from 'cl-library/dist/components/shared-components/EllipsisDropdown/index';
import Flex from 'cl-library/dist/components/shared-components/Flex/index';
import EditStudentDetail from './editDetails';
import LabelStudent from './labelChangeDetails';

const header = [
  { label: 'Date', key: 'Date' },
  { label: 'RM_code', key: 'rm_code' },
  { label: 'Token_no', key: 'token_no' },
  { label: 'Label_status', key: 'label_status' },
  { label: 'Label_problem', key: 'label_problem' },
  { label: 'English_label', key: 'English_label' },
  { label: 'English_worksheet_no', key: 'English_worksheet_no' },
  { label: 'English_mode_status', key: 'English_mode_status' },
];
const token = localStorage.getItem('token');

const TableData = ({ data }) => {
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState(data);
  const [edit, setEdit] = useState(false);
  const [labelEdit, setLabelEdit] = useState(false);
  const [editLabelDetail, setEditLabelDetail] = useState({});
  const [editDetail, setEditDetail] = useState({});

  const today = new Date().toISOString().slice(0, 10);
  const time = new Date().toLocaleTimeString();

  const csvRport = {
    filename: `English sheet ${today} ${time}`,
    headers: header,
    data: data,
  };

  const columns = [
    {
      title: 'Date',
      dataIndex: 'Date',
      key: 'Date',
      fixed: 'left',
      sorter: (a, b) => utils.antdTableSorter(a, b, 'Date'),
    },
    {
      title: 'RM Code',
      dataIndex: 'rm_code',
      key: 'rm_code',
      fixed: 'left',
      sorter: (a, b) => utils.antdTableSorter(a, b, 'rm_code'),
    },
    {
      title: 'Token No',
      dataIndex: 'token_no',
      key: 'token_no',
      fixed: 'left',
      sorter: (a, b) => utils.antdTableSorter(a, b, 'token_no'),
    },
    {
      title: 'Level status',
      dataIndex: 'label_status',
      key: 'label_status',
      fixed: 'left',
      sorter: (a, b) => utils.antdTableSorter(a, b, 'label_status'),
    },
    {
      title: 'Level problem',
      dataIndex: 'label_problem',
      key: 'label_problem',
      fixed: 'left',
      sorter: (a, b) => utils.antdTableSorter(a, b, 'label_problem'),
    },
    {
      title: 'Level no',
      dataIndex: 'English_label',
      key: 'English_label',
      fixed: 'left',
      sorter: (a, b) => utils.antdTableSorter(a, b, 'English_label'),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      fixed: 'left',
      sorter: (a, b) => utils.antdTableSorter(a, b, 'status'),
      render: (_, record, index) => (
        <Tag color={getStatus(record)}>{record.status}</Tag>
      ),
    },
    {
      title: 'Mode status',
      dataIndex: 'English_mode_status',
      key: 'English_mode_status',
      fixed: 'left',
      sorter: (a, b) => utils.antdTableSorter(a, b, 'English_mode_status'),
    },
    {
      title: 'Action',
      dataIndex: 'actions',
      fixed: 'left',
      render: (_, elm) => (
        <div>
          <EllipsisDropdown menu={dropdownMenu(elm)} disabled={true} />
        </div>
      ),
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      data.forEach((obj, index) => {
        obj.index = index;
      });
      setTableData(data);
      setLoading(false);
    };
    fetchData();
  }, [data]);

  const getStatus = (record) => {
    if (record.status === 'Done') {
      return 'success';
    }
    if (record.status === 'Pending') {
      return 'warning';
    }
    if (record.status === 'Duplicate') {
      return 'error';
    }
    return '';
  };

  const dropdownMenu = (elm) => (
    <Menu>
      {elm.status === 'Pending' != elm.status === 'Done' ||
      elm.status === 'Done' ? (
        <Menu.Item disabled={true}>
          <Flex alignItems="center">
            <span className="ml-2" onClick={() => showModal(elm)}>
              <EditOutlined className="mr-1" />
              Level Change Form
            </span>
          </Flex>
        </Menu.Item>
      ) : (
        <Menu.Item>
          <Flex alignItems="center">
            <span className="ml-2" onClick={() => showModal(elm)}>
              <EditOutlined className="mr-1" />
              Level Change Form
            </span>
          </Flex>
        </Menu.Item>
      )}
      {elm.status === 'Duplicate' || elm.status === 'Done' ? (
        <Menu.Item disabled={true}>
          <Flex alignItems="center">
            <span className="ml-2" onClick={() => EditStudent(elm)}>
              <EditOutlined className="mr-1" />
              Duplicate
            </span>
          </Flex>
        </Menu.Item>
      ) : (
        <Menu.Item>
          <Flex alignItems="center">
            <span className="ml-2" onClick={() => EditStudent(elm)}>
              <EditOutlined className="mr-1" />
              Duplicate
            </span>
          </Flex>
        </Menu.Item>
      )}
    </Menu>
  );

  const EditStudent = (elm) => {
    setEditDetail(elm);
    setEdit(true);
  };

  const showModal = (elm) => {
    setEditLabelDetail(elm);
    setLabelEdit(true);
  };

  const expandedRowRender = (record) => {
    return <MoreTableData record={record} />;
  };

  return (
    <Card
      title="Active Students"
      style={{ fontSize: '5px' }}
      extra={
        <CSVLink {...csvRport}>
          <DownloadOutlined style={{ fontSize: 30 }} />
        </CSVLink>
      }
    >
      {loading ? (
        <Spin tip="loading" />
      ) : (
        <>
          <Table
            xs={24}
            sm={50}
            md={50}
            columns={columns}
            dataSource={tableData}
            rowKey="index"
            expandable={{
              expandedRowRender,
            }}
          />
        </>
      )}
      {labelEdit && (
        <LabelStudent
          onCancel={() => setLabelEdit(false)}
          item={editLabelDetail}
          labelEdit={labelEdit}
        />
      )}
      {edit && (
        <EditStudentDetail
          onCancel={() => setEdit(false)}
          item={editDetail}
          showEdit={edit}
        />
      )}
    </Card>
  );
};

export default TableData;
